import * as DICT from "@/utils/dict"
import { downloadImg } from '@/utils/constant'
import { Tag } from "antd";
import React from "react";
import { connect } from "dva";
import CONST from "@/dataSource/CONST"

const { DeviceStateColor, ColorByKey } = CONST;

/** 设备状态 */  //  加loading是为了解决部分场景未触发刷新的问题
export class DeviceStateTag extends React.PureComponent {
    render() {
        const { state, style = {}, deviceStore, ...otherProps } = this.props
        return <Tag color={DeviceStateColor[state]}
            children={DICT.getValue('DEVICE_STATE_TYPE', state)}
            style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
            {...otherProps} />
    }
}

/** 告警名称 */
export const AlarmNameTag = ({ type, text, style = {}, ...otherProps }) => (
    <Tag color={ColorByKey[type]}
        children={text}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)
/** 告警级别 */
export const AlarmLevelTag = ({ type, text, style = {}, ...otherProps }) => (
    <Tag color={ColorByKey[type]}
        children={DICT.getValue('EVENT_TYPE', type)}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)

export const AlarmStateTag = ({ state, text, style = {}, ...otherProps }) => (
    <Tag color={ColorByKey[state]}
        children={DICT.getValue('DEVICE_ALARM_STATE', state)}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)
export const DeviceArmStateTag = ({ state, text, style = {}, ...otherProps }) => (
    <Tag color={ColorByKey['ARM_STATE_' + state]}
        children={DICT.getValue('ARM_STATE', state)}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)

export const DeviceStateTag2 = ({ state, text, style = {}, ...otherProps }) => (
    <Tag color={DeviceStateColor[state]}
        children={DICT.getValue('DEVICE_STATE_TYPE', state)}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)
export const ActionLogStateTag = ({ state, text, style = {}, ...otherProps }) => (
    <Tag color={ColorByKey[state]}
        children={DICT.getValue('ACTION_LOG_STATE', state)}
        style={{ ...{ fontSize: 'inherit', lineHeight: 'inherit' }, ...style }}
        {...otherProps} />)